import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --color-background: #000000;
    --color-text: #e0e0e0;
    --color-primary: #c0c0c0;
    --color-secondary: #808080;
    --color-accent: #a0a0a0;
    --color-gold: #d4af37;
    --color-gold-light: #fcf6ba;
    --color-gold-dark: #aa771c;
    --color-red: #a33;
    --color-red-light: #c55;
    --color-blue: #4682b4;
    --color-blue-light: #5f9ea0;
    --font-primary: 'Playfair Display', serif;
    --font-secondary: 'Raleway', sans-serif;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    font-family: var(--font-secondary);
    background-color: var(--color-background);
    color: var(--color-text);
    line-height: 1.6;
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-primary);
    font-weight: 700;
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 1rem;
  }

  a {
    color: var(--color-primary);
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: var(--color-accent);
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
  }

  @media (max-width: 768px) {
    html {
      font-size: 14px;
    }
  }
`;

export default GlobalStyles;
